import * as React from 'react';
import { ReactElement } from 'react';
import AppBar from '@mui/material/AppBar';
import { makeStyles } from '@mui/styles';
import Tabs, { TabsProps } from '@mui/material/Tabs';
import { useTranslatableContext } from 'ra-core';
import { TranslatableFieldsTab } from './TranslatableFieldsTab';
import { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import { ClassesOverride } from '../types';
import { Theme } from '@mui/material';
// import { AppBarProps } from '../layout';


export interface AppBarProps extends Omit<MuiAppBarProps, 'title' | 'classes'> {
    classes?: ClassesOverride<typeof useStyles>;
    logout?: React.ReactNode;
    open?: boolean;
    title?: string | JSX.Element;
    userMenu?: JSX.Element | boolean;
}


/**
 * Default locale selector for the TranslatableFields component. Generates a tab for each specified locale.
 * @see TranslatableFields
 */
export const TranslatableFieldsTabs = (
    props: TranslatableFieldsTabsProps & AppBarProps
): ReactElement => {
    const { groupKey, TabsProps: tabsProps } = props;
    const { locales, selectLocale, selectedLocale } = useTranslatableContext();
    const classes = useStyles(props);

    const handleChange = (event: React.SyntheticEvent, newLocale: string): void => {
        selectLocale(newLocale);
    };

    return (
        <AppBar color="default" position="static" className={classes.root}>
            <Tabs
                value={selectedLocale}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                {...tabsProps}
            >
                {locales.map(locale => (
                    <TranslatableFieldsTab
                        key={locale}
                        value={locale}
                        locale={locale}
                        groupKey={groupKey}
                    />
                ))}
            </Tabs>
        </AppBar>
    );
};

export interface TranslatableFieldsTabsProps {
    TabsProps?: TabsProps;
    groupKey?: string;
}

const useStyles = makeStyles<Theme>(
    theme => ({
        root: {
            boxShadow: 'none',
            borderRadius: 0,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            border: `1px solid ${theme.palette.divider}`,
        },
    }),
    { name: 'RaTranslatableFieldsTabs' }
);
